import {Component, Inject, Input, OnInit} from '@angular/core';
import {MatomoService} from '../../../../core/services/matomo.service';
import {AdsRestService} from '../../../../core/services/api/cms/ads.rest-service';
import {MatomoRequestModel} from '../../../../core/models/matomo.request.model';

@Component({
    selector: 'phx-ad-report',
    templateUrl: './ad-report.component.html',
    styleUrls: ['./ad-report.component.scss',
        '../supplier-report.component.scss'],
    standalone: false
})
export class AdReportComponent implements OnInit {
    @Input() selected;
    @Input() idfCount = 1;
    ad;
    click: number = 0;
    view: number = 0;
    group: number = 0;
    viewPerc: number = 0;
    adsForDate: any[] = [];
    resolutions = {};
    impressions: any = null;
    compares: any;
    days = 0;
    selectedImpressions: any;
    locations = [
        {value: 'ALL', viewValue: 'Alle'},
        {value: 'DASH', viewValue: 'Super Banner'},
        {value: 'RIGHT', viewValue: 'Rechts Skyscraper Banner'},
        {value: 'LEFT', viewValue: 'Links Skyscraper Banner'},
        {value: 'MENU', viewValue: 'Square Banner'},
        {value: 'PROMO', viewValue: 'Promotions Banner'}
    ];
    selectedClicks = 0;
    groupPercent = 0;
    parallels = 1;

    constructor(private matomoService: MatomoService,
                private adsService: AdsRestService,
                @Inject('CDN') public CDN) {
    }

    ngOnInit(): void {
        this.ad = this.selected.ad;
        this.compares = this.selected.compares;
        this.days = this.matomoService.getDateRange(new Date(this.ad.start), new Date(this.ad.end));

        let start = this.ad.start;
        let end = this.ad.end;

        this.adsService.getForDate(start,end).subscribe(ads => {
            const pars = ads.return_object.filter(ad => ad.location !== this.ad.location);

            console.log(pars);
            if(pars > 0) {
                this.parallels += pars.length;
            }

            console.log(this.parallels);
        })

        for(let compare of this.compares) {
            if (compare.start < start) {
                start = compare.start;
            }

            if(compare.end > end) {
                end = compare.end;
            }
        }

        this.getData(start, end);
    }

    private getData(startDate , endDate) {
        let requests = [];
        const resolutions = new MatomoRequestModel({
            method: 'Resolution.getResolution',
            id_site: 3,
            period: 'range',
            date: startDate + ',' + endDate,
            label: null
        });

        const impressions = new MatomoRequestModel({
            method: 'Contents.getContentPieces',
            id_site: 3,
            period: 'range',
            date: startDate + ',' + endDate,
            label: null
        });

        const ads = new MatomoRequestModel({
            id_site: 3,
            period: 'range',
            date: startDate + ',' + endDate,
            label: null,
            secondary_dimension: 'eventCategory',
            segment: 'dimension1%3D%3DApotheken',
            method: 'Events.getAction',
            filter_pattern: 'Klick auf Ads Banner'
        });

        this.matomoService.getAllData([resolutions, impressions, ads]).subscribe(bulk => {
            this.resolutions = this.matomoService.getResolutionNrs(bulk[0]);
            this.impressions = bulk[1];
            this.selectedImpressions = this.impressions.find(i => i.label.indexOf(this.ad.image) > -1);
            this.adsForDate = bulk[2];

            this.calculateClickPerformance();
            this.calculateTarget();
            this.calculateVisibility();
        });
    }

    calculateClickPerformance() {
        if (this.adsForDate.length > 0 && this.compares) {
            const title = this.ad.title.replace('+', ' ').trim();
            const selected = this.adsForDate.find(ad => ad.Events_EventAction.trim() === title);
            let compareReport = [];

            let compareBulk = [];

            this.selectedClicks = +(this.matomoService.calculateClicksPerDay(selected, this.days)).toFixed(2);

            let compareClicks = 0;
            let compareNr = 0;

            for (let compare of this.compares) {
                const compareReq = new MatomoRequestModel({
                    id_site: 3,
                    period: 'range',
                    date: compare.start + ',' + compare.end,
                    label: null,
                    secondary_dimension: 'eventCategory',
                    segment: 'dimension1%3D%3DApotheken',
                    method: 'Events.getAction',
                    filter_pattern: 'Klick auf Ads Banner'
                });

                compareBulk.push(compareReq);
            }

            this.matomoService.getAllData(compareBulk).subscribe(bulk=>{
                bulk.forEach((report: any, index: number): void => {
                    const selected = this.compares[index];
                    let compareDays = 0;
                    let title = selected.title.replace('+', ' ').trim();
                    compareDays = this.matomoService.getDateRange(new Date(selected.start), new Date(selected.end));

                    let comp = report.find(comp => comp.Events_EventAction.trim() === title);

                    if (comp) {
                        compareClicks += this.matomoService.calculateClicksPerDay(comp, compareDays);
                        compareNr++;
                    }
                });
                this.click = +((this.selectedClicks / (compareClicks / compareNr)).toFixed(2));
            });
        }
    }

    calculateTarget() {
        const idfs = this.ad.idfs.length;
        const selected = this.adsForDate.filter(ad => ad.Events_EventAction === this.ad.title)[0];
/*
* idfsday = nr idfs / days
* imprday = impressions / days
*
* (imprday/idfs) * 100
* percent of the targeted users that have seen the ad at least once in time period
* idf/visits * 100
* */

        if (idfs === 0) {
            this.group = 0;
        } else {
            this.group = +(this.matomoService.calculateTargetPerformance(idfs, this.selectedImpressions, this.days).toFixed(2));
            let compareGroup = 0;
            let compareNr = 0;
            let compareBulk = [];
            this.compares.forEach((compare) => {
                    const impressions = new MatomoRequestModel({
                    method: 'Contents.getContentPieces',
                    id_site: 3,
                    period: 'range',
                    date: compare.start + ',' + compare.end,
                    label: null
                });

                compareBulk.push(impressions);
            });

            this.matomoService.getAllData(compareBulk).subscribe(bulk => {
                bulk.forEach((impress: any, index: number): void => {
                   const selected = this.compares[index]
                   const selectedImpressions = impress.find(i => i.label.indexOf(selected.image) > -1);
                   compareGroup += +(this.matomoService.calculateTargetPerformance(selected.idfs, selectedImpressions, this.days).toFixed(2));
                });
                compareNr = this.compares.length;
                this.groupPercent = +((this.group/(compareGroup/compareNr)).toFixed(2));
            });
        }
    }

    calculateVisibility() {
        const selectedVis = this.matomoService.calculateAdVisibility(this.ad, this.selectedImpressions, this.resolutions, this.parallels, this.idfCount);
        let compareVis = 0;
        this.view = +(selectedVis).toFixed(2);


            this.compares.forEach((compare) => {

                this.matomoService.getImpressions(compare.start, compare.end).subscribe(impressList => {
                    const selectedImpressions = impressList.find(i => i.label.indexOf(compare.image) > -1);

                    this.adsService.getForDate(compare.start, compare.end).subscribe(ads => {
                        let n = 1;
                        const pars = ads.return_object.filter(ad => ad.location !== compare.location);

                        if(pars > 0) {
                            n += pars.length;
                        }

                        compareVis += +(this.matomoService.calculateAdVisibility(compare, selectedImpressions, this.resolutions, n, (compare.idfs.length > 0) ? compare.idfs.length : 1).toFixed(2));
                    })
                });
            });


        this.viewPerc = +((selectedVis / (compareVis/this.compares.length)).toFixed(2));
        //same perc like the first one 0-200%
    }

    getDate(date) {
        return new Date(date);
    }

    getAdLocation(loc) {
        return this.locations.find(x => x.value === loc)?.viewValue;
    }

    getStatus(element, type) {
        const channels = element.channels.filter(channel => channel.type === type);
        //channels je array channela koji su odredjeni tip, length 0 ako nema niti jednog

        let statuses = [];
        channels.forEach(channel=> {
            if(!statuses.find(status=> status===channel.status)) {
                statuses.push({status: channel.status, nr: 1});
            } else {
                let ind = statuses.indexOf(st => st.status === channel.status);
                if(ind >-1) {
                    statuses[ind].nr++;
                }
            }
        });

        return statuses;
    }
}
